export const getNetworksIdsByNames = (networksName, networksData) => {
    return networksName?.map(networkName => {
        const currentNetworkData = networksData?.find(networkData => {
            return networkData.alias === networkName;
        });

        return currentNetworkData?.id;
    }) || [];
};
